import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    trueBlack: {
      100: '#4040400',
      200: '#3333330',
      300: '#2626260',
      400: '#1a1a1a0',
      500: '#000000',
      600: '#000000',
      700: '#000000',
      800: '#000000',
      900: '#000000',
    },
    brand: {
      primary: '#F2B807',
      second: '#F28F16',
      third: '#F5DB13',
      danger: '#D93E30',
      white: '#F6F7F9',
      black: '#212121',
    },
    types: {
      normal: {
        100: '#e0e1e0',
        200: '#d3d4d3',
        300: '#c6c8c6',
        400: '#babbb9',
        500: '#A0A29F',
        600: '#868985',
        700: '#7a7c78',
        800: '#6d6f6c',
        900: '#545553',
      },
      fighting: {
        100: '#edacb8',
        200: '#e897a6',
        300: '#e48294',
        400: '#df6d83',
        500: '#D6435F',
        600: '#bd2945',
        700: '#a8253e',
        800: '#932036',
        900: '#691727',
      },
      flying: {
        100: '#ffffff',
        200: '#eef4fc',
        300: '#d9e6f8',
        400: '#c3d8f4',
        500: '#98BCEC',
        600: '#6da0e4',
        700: '#5792e0',
        800: '#4284dc',
        900: '#256ac6',
      },
      poison: {
        100: '#e2c7ed',
        200: '#d8b4e7',
        300: '#cea0e1',
        400: '#c48ddb',
        500: '#B066CF',
        600: '#9c3fc3',
        700: '#8d38b1',
        800: '#7e319e',
        900: '#5f2577',
      },
      ground: {
        100: '#f2cbb9',
        200: '#eebba3',
        300: '#eaab8e',
        400: '#e69c78',
        500: '#DE7C4D',
        600: '#d15e27',
        700: '#bc5423',
        800: '#a64b1f',
        900: '#7b3717',
      },
      rock: {
        100: '#f4f0e5',
        200: '#ece5d3',
        300: '#e5dbc1',
        400: '#ddd0af',
        500: '#CEBB8B',
        600: '#bfa667',
        700: '#b79b55',
        800: '#ab8f48',
        900: '#877139',
      },
      bug: {
        100: '#cde18b',
        200: '#c4db77',
        300: '#bbd663',
        400: '#b2d14e',
        500: '#9BBB31',
        600: '#7a9326',
        700: '#697e21',
        800: '#586a1c',
        900: '#374211',
      },
      ghost: {
        100: '#aabadf',
        200: '#98abd8',
        300: '#859cd1',
        400: '#738dca',
        500: '#4E6FBC',
        600: '#3b589c',
        700: '#344e89',
        800: '#2d4377',
        900: '#1f2e52',
      },
      steel: {
        100: '#a0c9d1',
        200: '#8fbfc9',
        300: '#7eb5c0',
        400: '#6dacb8',
        500: '#4F95A3',
        600: '#3e7681',
        700: '#36666f',
        800: '#2e565e',
        900: '#1d373c',
      },
      fire: {
        100: '#ffe5cd',
        200: '#ffd9b3',
        300: '#ffcc9a',
        400: '#ffbf80',
        500: '#FFA54D',
        600: '#ff8b1a',
        700: '#ff7e01',
        800: '#e67200',
        900: '#b35800',
      },
      water: {
        100: '#a2d3f0',
        200: '#8cc8ed',
        300: '#76bee9',
        400: '#60b3e6',
        500: '#349EDF',
        600: '#1f84c1',
        700: '#1b75ab',
        800: '#186695',
        900: '#114869',
      },
      grass: {
        100: '#bce1b5',
        200: '#acdaa3',
        300: '#9bd391',
        400: '#8bcc7e',
        500: '#6ABD5A',
        600: '#51a341',
        700: '#48913a',
        800: '#3f7e33',
        900: '#2d5a24',
      },
      electric: {
        100: '#fef4cd',
        200: '#fdeeb4',
        300: '#fde99b',
        400: '#fce382',
        500: '#FBD850',
        600: '#facd1e',
        700: '#f9c706',
        800: '#e0b305',
        900: '#ae8b04',
      },
      psychic: {
        100: '#ffffff',
        200: '#ffe7e6',
        300: '#ffcecd',
        400: '#feb6b4',
        500: '#FE8581',
        600: '#fe544e',
        700: '#fd3c35',
        800: '#fd231c',
        900: '#e40902',
      },
      ice: {
        100: '#d2f0ec',
        200: '#bfeae3',
        300: '#ace3db',
        400: '#99ddd3',
        500: '#73D0C2',
        600: '#4dc3b1',
        700: '#3eb9a6',
        800: '#38a595',
        900: '#2b7f73',
      },
      dragon: {
        100: '#48abff',
        200: '#2e9fff',
        300: '#1594ff',
        400: '#0088fa',
        500: '#006CC7',
        600: '#005094',
        700: '#00427b',
        800: '#003561',
        900: '#00192e',
      },
      dark: {
        100: '#9796a1',
        200: '#8a8995',
        300: '#7d7b89',
        400: '#706f7c',
        500: '#585761',
        600: '#403f46',
        700: '#333339',
        800: '#27272b',
        900: '#0f0f10',
      },
      fairy: {
        100: '#ffffff',
        200: '#fbe9fa',
        300: '#f7d4f5',
        400: '#f3beef',
        500: '#EB93E5',
        600: '#e368db',
        700: '#df52d5',
        800: '#db3dd0',
        900: '#c124b6',
      },
      unknown: {
        100: '#9796a1',
        200: '#8a8995',
        300: '#7d7b89',
        400: '#706f7c',
        500: '#585761',
        600: '#403f46',
        700: '#333339',
        800: '#27272b',
        900: '#0f0f10',
      },
      shadow: {
        100: '#9796a1',
        200: '#8a8995',
        300: '#7d7b89',
        400: '#706f7c',
        500: '#585761',
        600: '#403f46',
        700: '#333339',
        800: '#27272b',
        900: '#0f0f10',
      },
    },
  },
  fonts: {
    karla: 'Karla, sans-serif',
    sourceSans: 'Source Sans Pro, sans-serif',
    anton: 'Anton, sans-serif',
  },
});

export default theme;
